import { Stack, Text } from 'braid-design-system';

import { ProfileMenuItem } from './ProfileMenuItem.tsx';

import { useLogin, usePermissions } from '#src/hooks/auth.tsx';
import { useOrganizations } from '#src/pages/manage/organizations/OrganizationContext.tsx';

export const OrganizationSelection = () => {
  const { organizations } = useOrganizations();
  const { integrationPartnerUuid } = usePermissions();
  const { login } = useLogin();
  const otherPartners = organizations.filter(
    (org) => org.integrationPartnerUuid !== integrationPartnerUuid,
  );
  return (
    <Stack space="none">
      {otherPartners.map((org) => (
        <ProfileMenuItem
          key={`org-menu-item-${org.id}`}
          onClick={async () => {
            await login({
              organization: org.id,
            });
          }}
        >
          <Text size="small">{org.name}</Text>
        </ProfileMenuItem>
      ))}
    </Stack>
  );
};
